const tokenKey = `${process.env.PUBLIC_URL}_token`;
const currentUserKey = `${process.env.PUBLIC_URL}_currentUser`;
const themeKey = `${process.env.PUBLIC_URL}_themeIsDark`;

export { tokenKey, currentUserKey, themeKey };
